(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("input[data-v-e2132f34]{min-width:0;background:none;outline:none}")),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { onClickOutside as le } from "@vueuse/core";
import { defineComponent as re, ref as f, toRefs as ae, computed as d, reactive as ne, watch as de, nextTick as A, resolveComponent as p, openBlock as B, createElementBlock as se, normalizeClass as E, createBlock as P, withCtx as r, renderSlot as v, createTextVNode as m, toDisplayString as i, createCommentVNode as D, createVNode as w, createSlots as I, createElementVNode as R, withDirectives as q, mergeProps as ie, withKeys as ue, vModelDynamic as pe, vShow as U } from "vue";
import { useResponsive as fe, useIdAttribute as ve, useControlAttributes as me, useValidationAttributes as ye, useProxyModelValue as ge } from "@onereach/ui-components-common/hooks";
import { toArray as be, include as ce, exclude as he } from "@onereach/ui-components-common/utils";
import { O as Oe } from "./OrError-B5ihH6-3.mjs";
import { O as Be } from "./OrHint-NvbZyURY.mjs";
import { O as we } from "./OrIconButton-BlHCLpeW.mjs";
import { O as Ie } from "./OrInputBox-6ciokFdU.mjs";
import { a as Ve } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as ke } from "./OrLabel-BadqqO3K.mjs";
import { O as Se } from "./OrLoader-2SaTMxmZ.mjs";
import { a as j } from "./OrTag-Bixe0EQq.mjs";
import { O as $e, T as G } from "./OrTags-CS0bcLtx.mjs";
import { _ as Le } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const Me = [
  // Layout
  "layout-column",
  // Spacing
  "gap-xs"
], Ce = [
  // Layout
  // 'flex-auto',
  // Typography
  "typography-inherit",
  // Theme (placeholder)
  "placeholder:theme-foreground-outline",
  "dark:placeholder:theme-foreground-outline-dark"
], Te = [
  // Box
  "!min-h-0"
], Ae = re({
  name: "OrTagInput",
  components: {
    OrError: Oe,
    OrHint: Be,
    OrIconButton: we,
    OrInputBox: Ie,
    OrLabel: ke,
    OrLoader: Se,
    OrTags: $e
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: () => []
    },
    variant: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    overflow: {
      type: String,
      default: () => G.Hidden
    },
    // todo: review default state, disabling will breaking
    enableClear: {
      type: Boolean,
      default: !0
    },
    additionalInputBoxStyles: {
      type: Array,
      default: () => []
    },
    saveOnBlur: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur",
    "reset"
  ],
  expose: [
    "root",
    "reset",
    "clear",
    "focus",
    "blur",
    "activate"
  ],
  setup(e, t) {
    const H = f(), g = f(), V = f(), b = f(), { modelValue: k, overflow: S, placeholder: $, disabled: y, readonly: c, saveOnBlur: L } = ae(e), { isMobile: M } = fe(), l = d(() => [
      "or-tag-input-v3",
      ...Me,
      ...e.variant === Ve.Embedded ? ["grow"] : []
    ]), J = d(() => [
      ...Ce
    ]), Q = d(() => [
      ...Te
    ]), W = d(() => [
      "interactivity-select",
      ...e.additionalInputBoxStyles
    ]), N = ne({
      id: ve(),
      ...me(),
      ...ye()
    }), u = f(!1), n = ge(k, t.emit), s = f(), X = d(() => be(n.value).map((o) => ({
      label: o,
      value: o,
      tagProps: {
        color: o === s.value ? j.Danger : j.Default
      }
    }))), h = d(() => {
      var o;
      return ((o = n.value) == null ? void 0 : o.length) ?? 0;
    }), C = d(() => N.maxlength), Y = d(() => {
      var a;
      const o = s.value ? s.value.length : h.value === 0 ? ((a = $.value) == null ? void 0 : a.length) ?? 0 : 0;
      return {
        width: `${Math.max(o + 1 || 0, 3)}ch`
      };
    }), Z = d(() => s.value || h.value === 0 || u.value), x = d(() => ({
      variant: c.value || y.value || !u.value ? "tag" : "reset",
      disabled: y.value
    }));
    function T() {
      var o;
      (o = g.value) == null || o.focus();
    }
    function z() {
      var o;
      (o = g.value) == null || o.blur();
    }
    function F() {
      u.value = !1, A(() => z()), t.emit("blur");
    }
    function _() {
      y.value || c.value || (u.value || (u.value = !0, t.emit("focus")), A(() => T()));
    }
    function K() {
      var a;
      const o = s.value;
      o && ((a = n.value) != null && a.includes(o) || C.value && h.value >= C.value || (n.value = ce(o, n.value ?? []), s.value = "", A(() => T())));
    }
    function ee(o) {
      n.value = he(o, n.value ?? []);
    }
    function oe() {
      n.value = [], s.value = "", t.emit("reset");
    }
    function te() {
      s.value = "";
    }
    return le(V, () => {
      var o, a;
      u.value === !1 || ((a = (o = b.value) == null ? void 0 : o.overflowPopover) == null ? void 0 : a.state) === "open" || (L.value && K(), F());
    }), de(n, (o, a) => {
      var O;
      S.value === G.Scroll && (o == null ? void 0 : o.length) !== (a == null ? void 0 : a.length) && ((O = b.value) == null ? void 0 : O.scrollToEnd).call(O);
    }), {
      root: H,
      control: g,
      inputBox: V,
      tags: b,
      rootStyles: l,
      controlStyles: J,
      itemStyles: Q,
      inputBoxStyles: W,
      controlInlineStyles: Y,
      controlAttributes: N,
      proxyModelValue: n,
      draftModelValue: s,
      tagsItems: X,
      tagsProps: x,
      currentLength: h,
      maxLength: C,
      activated: u,
      showControl: Z,
      isMobile: M,
      focus: T,
      blur: z,
      add: K,
      activate: _,
      deactivate: F,
      remove: ee,
      reset: oe,
      clear: te
    };
  }
}), Ee = { class: "inline-flex w-fit max-w-full" }, Pe = ["placeholder", "readonly", "disabled"];
function De(e, t, H, g, V, b) {
  const k = p("OrLabel"), S = p("OrTags"), $ = p("OrLoader"), y = p("OrIconButton"), c = p("OrInputBox"), L = p("OrHint"), M = p("OrError");
  return B(), se("div", {
    ref: "root",
    class: E(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (B(), P(k, {
      key: 0,
      "control-id": e.controlAttributes.id,
      variant: "input",
      required: e.required,
      disabled: e.disabled
    }, {
      addon: r(() => [
        v(e.$slots, "addon", {}, void 0, !0)
      ]),
      default: r(() => [
        v(e.$slots, "label", {}, () => [
          m(i(e.label), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["control-id", "required", "disabled"])) : D("", !0),
    w(c, {
      ref: "inputBox",
      class: E(e.inputBoxStyles),
      variant: e.variant,
      invalid: !!e.error,
      readonly: e.readonly,
      disabled: e.disabled,
      tabindex: 0,
      "force-state": e.activated ? "focus-within" : void 0,
      onFocus: e.activate
    }, I({
      default: r(() => [
        w(S, {
          ref: "tags",
          class: E(["grow"]),
          items: e.tagsItems,
          disabled: e.disabled,
          "tag-props": e.tagsProps,
          overflow: e.overflow,
          onReset: t[6] || (t[6] = (l) => e.remove(l))
        }, I({
          tag: r(({ item: l }) => [
            v(e.$slots, "tag", { item: l }, () => [
              m(i(l.label), 1)
            ], !0)
          ]),
          _: 2
        }, [
          e.showControl ? {
            name: "tail",
            fn: r(() => [
              R("div", Ee, [
                q(R("input", ie({ ref: "control" }, e.controlAttributes, {
                  "onUpdate:modelValue": t[0] || (t[0] = (l) => e.draftModelValue = l),
                  class: e.controlStyles,
                  style: e.controlInlineStyles,
                  type: "text",
                  placeholder: !e.proxyModelValue || e.proxyModelValue && e.proxyModelValue.length === 0 ? e.placeholder : void 0,
                  readonly: e.readonly,
                  disabled: e.disabled,
                  autocomplete: "off",
                  minlength: void 0,
                  maxlength: void 0,
                  onInput: t[1] || (t[1] = (l) => e.$emit("input", l)),
                  onKeydown: [
                    t[2] || (t[2] = (l) => e.$emit("keydown", l)),
                    t[3] || (t[3] = ue((l) => e.add(), ["enter"]))
                  ],
                  onKeyup: t[4] || (t[4] = (l) => e.$emit("keyup", l)),
                  onFocus: t[5] || (t[5] = (...l) => e.activate && e.activate(...l))
                }), null, 16, Pe), [
                  [
                    pe,
                    e.draftModelValue,
                    void 0,
                    { trim: !0 }
                  ]
                ])
              ])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "disabled", "tag-props", "overflow"])
      ]),
      _: 2
    }, [
      e.$slots.prependInner ? {
        name: "prepend",
        fn: r(() => [
          v(e.$slots, "prependInner", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      e.$slots.appendInner ? {
        name: "addon",
        fn: r(() => [
          v(e.$slots, "appendInner", {}, void 0, !0)
        ]),
        key: "1"
      } : e.loading ? {
        name: "addon",
        fn: r(() => [
          w($, {
            variant: "circular",
            color: e.error ? "danger" : "primary",
            size: e.isMobile ? "m" : "s"
          }, null, 8, ["color", "size"])
        ]),
        key: "2"
      } : e.enableClear && !e.readonly && !e.disabled ? {
        name: "addon",
        fn: r(() => [
          e.proxyModelValue && e.proxyModelValue.length > 0 || e.draftModelValue ? (B(), P(y, {
            key: 0,
            icon: "close",
            color: "inherit",
            onClick: t[7] || (t[7] = (l) => e.reset())
          })) : D("", !0)
        ]),
        key: "3"
      } : void 0
    ]), 1032, ["class", "variant", "invalid", "readonly", "disabled", "force-state", "onFocus"]),
    e.$slots.hint || e.hint || e.maxLength ? q((B(), P(L, {
      key: 1,
      disabled: e.disabled
    }, I({
      default: r(() => [
        v(e.$slots, "hint", {}, () => [
          m(i(e.hint), 1)
        ], !0)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: r(() => [
          m(i(e.currentLength) + " / " + i(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"])), [
      [U, !e.error]
    ]) : D("", !0),
    q(w(M, { disabled: e.disabled }, I({
      default: r(() => [
        m(i(e.error) + " ", 1)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: r(() => [
          m(i(e.currentLength) + " / " + i(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"]), [
      [U, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const Ye = /* @__PURE__ */ Le(Ae, [["render", De], ["__scopeId", "data-v-e2132f34"]]);
export {
  Ye as O
};
//# sourceMappingURL=OrTagInput-B5TArhY_.mjs.map
